import React from 'react';
import styles from './Button.module.css';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  style = {}
}) => {
  const variantClass = styles[variant] || styles.primary;
  const sizeClass = size === 'sm' ? styles.sizeSm : size === 'lg' ? styles.sizeLg : styles.sizeMd;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={style}
      className={`${styles.button} ${variantClass} ${sizeClass} ${className}`.trim()}
    >
      {children}
    </button>
  );
};

export default Button;
